import { Typography } from '@mui/material'

export const Login = () => {
    return (
        <Typography>
            В разработке
        </Typography>
    )
}
